'use client';

import { Product } from 'shared/types/product/Product';
import ProductSlider, { ProductSliderProps } from 'components/gruenland/organisms/product-slider/ProductSlider';
import { desktop } from 'helpers/utils/screensizes';
import { DataSource } from 'types/datasource';
import { useWishlist } from 'frontastic/hooks';
import { TasticProps } from 'frontastic/tastics/types';
import { TYPOGRAPHY_PRODUCT_DETAIL_TITLE } from 'lib/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import classNames from 'classnames';

function YggdrasilRelatedProductsTastic({ data }: TasticProps<DataSource<{ items: Product[] }> & ProductSliderProps>) {
  const { data: wishlist, addToWishlist, removeLineItem } = useWishlist();
  const { formatMessage } = useFormat({ name: 'gruenland' });

  if (!data?.data?.dataSource?.items) return <></>;

  const Slider = (
    <>
      <h2 className={classNames(TYPOGRAPHY_PRODUCT_DETAIL_TITLE, 'text-center')}>
        {formatMessage({ id: 'pdp.relatedTitle', defaultMessage: 'Potrebbero piacerti anche' })}
      </h2>
      <div className="mt-6">
        <ProductSlider
          // {...data}
          wishlist={wishlist}
          products={data.data.dataSource.items ?? []}
          addToWishlist={async (lineItem, count) => {
            if (wishlist) await addToWishlist(wishlist, lineItem, count);
          }}
          removeLineItem={async (lineItem) => {
            if (wishlist) await removeLineItem(wishlist, lineItem);
          }}
          slidesPerView={1.5}
          slidesPerGroup={1}
          breakpoints={{
            [desktop]: {
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
          }}
        />
      </div>
    </>
  );

  if (data.variant === 'cart') return <div className="bg-neutral-200 pb-[64px]">{Slider}</div>;

  return Slider;
}

export default YggdrasilRelatedProductsTastic;
